// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XPRAH","container":"Header_container__doDRB","title":"Header_title__oq3xC","btn":"Header_btn__08tP9"};